import { Component, OnInit, Input } from '@angular/core';
import { APP_CONFIG } from 'src/app/config';
import { environment } from 'src/environments/environment';
declare const window;

@Component({
  selector: 'app-sidenav-footer',
  templateUrl: './sidenav-footer.component.html',
  styleUrls: ['./sidenav-footer.component.scss']
})
export class SidenavFooterComponent implements OnInit {

  @Input() footerHeight: number;
  @Input() sidenavOpened: boolean;
  appVersion: string;
  environment: string;

  constructor() {
    this.checkEvironment();
  }

  ngOnInit() {
    this.appVersion = APP_CONFIG.appVersion;
  }

  public checkEvironment() {
    switch (environment.envName) {
        case 'dev':
         this.environment = 'DEV';
        break;
        case 'demo':
         this.environment = 'DEMO';
        break;
        case 'belen':
         this.environment = 'BELEN';
        break;
        case 'paco':
         this.environment = 'PACO';
        break;
    }
  }

  public openChangelog() {
    window.open('https://changelogfy.com/mbase/announcements');
  }
}
